import type { LogPayload } from '../types.js';

export function shouldSample(rate: number): boolean {
  if (rate >= 1) return true;
  if (rate <= 0) return false;
  return Math.random() < rate;
}

export interface DedupeStore {
  shouldDrop(payload: LogPayload): boolean;
}

export function createDedupeStore(windowMs: number): DedupeStore {
  if (windowMs <= 0) {
    return { shouldDrop: () => false };
  }
  const seen = new Map<string, number>();
  return {
    shouldDrop(payload: LogPayload): boolean {
      const key = `${payload.level}|${payload.message}|${payload.errorName ?? ''}`;
      const now = Date.now();
      const last = seen.get(key);
      if (last !== undefined && now - last < windowMs) {
        return true;
      }
      seen.set(key, now);
      if (seen.size > 256) {
        const cutoff = now - windowMs;
        for (const [k, ts] of seen) {
          if (ts < cutoff) seen.delete(k);
        }
      }
      return false;
    },
  };
}
